import styled, { css } from 'styled-components';
import { breakpointDown } from '/shared/styled/Breakpoints';

interface Props {
  $centred?: boolean;
  $right?: boolean;
  $lessTopPadding?: boolean;
  $customTopPadding?: string | false;
  $indented?: boolean;
  $smallerIndent?: boolean;
}

function centredStyle({ $centred = false }: Props) {
  if ($centred) {
    return css`
      display: flex;
      align-items: center;
      justify-content: center;
    `;
  }
}

function rightStyle({ $right = false }: Props) {
  if ($right) {
    return css`
      display: flex;
      justify-content: flex-end;
    `;
  }
}

function lessTopPaddingStyle({ $lessTopPadding = false }: Props) {
  if ($lessTopPadding) {
    return css`
      margin-top: 1rem;
      ${breakpointDown('mobile')} {
        margin-top: 0.75rem;
      }
    `;
  }
}

function customTopPaddingStyle({ $customTopPadding = false }: Props) {
  if ($customTopPadding) {
    return css`
      margin-top: ${$customTopPadding};
    `;
  }
}

function indentedStyle({ $indented, $smallerIndent = false }: Props) {
  if ($indented) {
    if ($smallerIndent) {
      return css`
        padding-left: 5rem;
      `;
    }
    return css`
      margin-left: -0.5rem;
      padding-left: 42.85%;
    `;
  }
}

export default styled.div<Props>`
  margin-top: 4rem;
  width: 100%;
  ${breakpointDown('mobile')} {
    margin-top: 2.5rem;
  }
  ${lessTopPaddingStyle}
  ${customTopPaddingStyle}
  ${indentedStyle}
  ${centredStyle}
  ${rightStyle}
`;
